module.exports = __webpack_public_path__ + "img/video_transter.eeb1584a.svg";